import { Textfield } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import type { CrmEnrichmentJobType, CrmEnrichmentSource } from "../../../types/types";
import { StyledCrmEnrichmentJobSetting } from "../../styles";
import Caption from "../../wizard/Caption";
import EnrichmentLevelRadio from "../EnrichmentLevelRadio";
import JobTypeSwitcher from "../JobTypeSwitcher/JobTypeSwitcher";

import { StyledJobEditorBanner, StyledJobEditorInputWrapper } from "./styles";

type Props = {
    jobName: string;
    type: CrmEnrichmentJobType;
    enrichmentSource: CrmEnrichmentSource;
    onSetJobName: (value: string) => void;
};

const JobType = ({ jobName, onSetJobName, type, enrichmentSource }: Props) => {
    return (
        <>
            <StyledJobEditorInputWrapper>
                <Caption captionKey="si.crm-enrichment.job-editor.name" />

                <Textfield
                    defaultValue={jobName}
                    placeholder={translate("si.crm-enrichment.name-modal.placeholder")}
                    autoFocus
                    onChange={(value) => onSetJobName(value)}
                />
            </StyledJobEditorInputWrapper>

            <div>
                <Caption captionKey="si.crm-enrichment.job-wizard.review.type" />

                <StyledCrmEnrichmentJobSetting>
                    <JobTypeSwitcher type={type} />
                </StyledCrmEnrichmentJobSetting>
            </div>

            <div>
                <Caption
                    captionKey="si.crm-enrichment.job-wizard.settings.enrichment-level.caption"
                    tooltipKey="si.crm-enrichment.job-wizard.settings.enrichment-level.tooltip"
                />

                <EnrichmentLevelRadio
                    isDisabled
                    selectedEnrichmentSource={enrichmentSource}
                />
            </div>

            <StyledJobEditorBanner>
                <I18n translatable={{ key: "si.crm-enrichment.hs.job-editor.type.warning" }} />
            </StyledJobEditorBanner>
        </>
    );
};

export default JobType;
